"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function BreadcrumbTrailElement(props) {
    const { name, selected, style, getButtonElement, onClick } = props;
    const getBackgroundElement = (0, react_1.useRef)(null);
    const itemElement = (0, react_1.useRef)(null);
    const [opacityEl, setOpacityEl] = (0, react_1.useState)(0);
    const [widthEl, setWidthEl] = (0, react_1.useState)(0);
    const getElement = (itemRef) => {
        if (!itemRef)
            return;
        getButtonElement(itemRef);
        itemElement.current = itemRef;
    };
    const updateLayout = () => {
        setOpacityEl(0);
        if (itemElement && itemElement.current) {
            setTimeout(() => {
                setOpacityEl(1);
            }, 200);
            setWidthEl(itemElement.current.offsetWidth);
        }
    };
    (0, react_1.useEffect)(() => {
        updateLayout();
    }, [name]);
    return ((0, jsx_runtime_1.jsxs)(Item, { ref: getElement, style: style, onClick: onClick, "$selected": selected, "data-e2e": 'BreadcrumbTrailElement_Item', children: [(0, jsx_runtime_1.jsx)(Background, { ref: getBackgroundElement, "$width": widthEl, "$selected": selected, "data-e2e": 'BreadcrumbTrailElement_Background' }), (0, jsx_runtime_1.jsx)(ItemText, { style: { opacity: opacityEl }, "data-e2e": 'BreadcrumbTrailElement_ItemText', children: name })] }));
}
exports.default = BreadcrumbTrailElement;
const Item = (0, styled_components_1.default)(ui_1.FlatButton) `
  position: absolute;
  left: 0;

  display: flex;
  align-items: center;
  box-sizing: border-box;

  height: 30px;
  margin: 0 4px;
  padding: 8px;

  font-size: 16px;
  white-space: nowrap;
  text-transform: uppercase;

  opacity: 0;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;

  overflow: initial;
  pointer-events: initial;

  line-height: 18.32px;
  font-weight: ${({ $selected }) => ($selected ? 700 : 'normal')};

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    border: 2px solid ${({ theme }) => theme.designSystem.accent};
  }

  color: ${({ theme, $selected }) => $selected ? theme.text : theme.textSecondary};
  ${({ theme, $selected }) => $selected
    ? (0, styled_components_1.css) `
          background-color: ${theme.grasshopper.menuButtons.selectedBackground};
        `
    : (0, styled_components_1.css) `
          background-color: ${theme.breadcrumbTrail.background};
        `};
  border-radius: 4px;

  &:hover {
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.grasshopper.menuButtons.selectedBackground};
  }
`;
const Background = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  width: ${({ $width }) => `${$width}px`};

  transform-origin: 0 50%;

  transition: width 0.2s ease-in-out, max-width 1s;
`;
const ItemText = (0, ui_1.withFakeBold)(styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  font-family: 'Elsevier Sans', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  transition: width 0.2s ease-in-out, max-width 1s, opacity 0.2s ease-in-out;
`);
